import { render } from "./Conversation.vue?vue&type=template&id=adb5a0ee"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=adb5a0ee&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__